const digest = 'fea83f8952670b71a24ece4a602648f888dc51d4b3c81935518ad1c849ccee6f';
const css = `._signature_1vdlu_1{max-height:4.5rem}._resyButton_1vdlu_5:focus{border-radius:.25rem;outline-width:.0625rem}._resyButton_1vdlu_5:focus,._resyButton_1vdlu_5:hover{text-decoration-thickness:.063rem;text-underline-offset:.125rem}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'signature': '_signature_1vdlu_1', 'resyButton': '_resyButton_1vdlu_5' };
export const signature = '_signature_1vdlu_1';
export const resyButton = '_resyButton_1vdlu_5';
export { css, digest };